module.exports = __webpack_public_path__ + "img/empty.6b4b9759.svg";